import React from 'react'
import {
  HubResponsiveValue,
  HubStyleObject,
  useToken,
} from '@hub/design-system-base'

import { Stack } from '@hub/stack'
import { Text } from '@hub/text'
import { H2 } from '@hub/heading'
import { LinkButtonOverlay, LinkOverlay } from '@hub/link'

interface ContentStackProps {
  sx?: HubStyleObject
  title: string
  shortDescription?: string
  callToActionLabel?: string
  url?: string
  color: HubResponsiveValue<string> // TODO: This is a CSS colour string, can it be stricter?
  centered?: boolean
  textShadow?: HubResponsiveValue<string>
}

export const ContentStack: React.FC<ContentStackProps> = ({
  sx,
  title,
  shortDescription,
  callToActionLabel,
  url,
  color,
  centered = false,
  textShadow,
}) => {
  const defaultColor = useToken('colors', 'licorice')
  const hoverColor = useToken(
    'colors',
    defaultColor === color ? 'quartz' : 'ghost'
  )

  return (
    <Stack
      shouldWrapChildren={false}
      sx={{ ...(!centered && { alignItems: 'flex-start' }), ...sx }}
      gap="spacing-md"
    >
      <Stack shouldWrapChildren={false} gap="spacing-sm">
        <H2 align={centered ? 'center' : 'left'} sx={{ color, textShadow }}>
          {!callToActionLabel && url ? (
            <LinkOverlay href={url}>{title}</LinkOverlay>
          ) : (
            title
          )}
        </H2>
        {shortDescription ? (
          <Text align={centered ? 'center' : 'left'} sx={{ color, textShadow }}>
            {shortDescription}
          </Text>
        ) : null}
      </Stack>
      {callToActionLabel && url ? (
        <LinkButtonOverlay
          href={url}
          variant="outline"
          sx={{
            borderColor: color,
            color,
            '&:hover': {
              textDecoration: 'none',
              '@media (hover: hover)': {
                borderColor: hoverColor,
                color: hoverColor,
              },
            },
          }}
        >
          {callToActionLabel}
        </LinkButtonOverlay>
      ) : null}
    </Stack>
  )
}
